<template>
      <div no-body class="lku-area"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="pt-2 mr-3">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblArea"
          responsive outlined
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :key="tblData.page"
          :filter="filter"
          @filtered="onFiltered"                
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>

        </b-table>
      <b-row>
        <b-col cols="7">
          <b-row>
              <span class="pt-1 pr-1">Per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:60px !important;"/>
              <div class="pl-1 pt-1">
                showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} 
              </div>        
          </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-area {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            label: "No.",
            thStyle: "width:80px",
            tdstyle: "padding-left:5px;",

          },
          {
            key: "area_name",
            label: "group/Area",
            sortable: true
          },

      ],
      items:[],
      tblData: {
        tablename: "koranarea",
        page: 1,
        limit:10000,
        total: 0,
        sortBy: 'area_name',
        sortDesc: false
      },
      updatetable:false,
      filter:null
    };
  },
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    data: async function(ctx) {
      this.tblData.limit=10000;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await crud.list(this.tblData);      
      this.lkuLoading=false;
      this.items=list;
      this.tblData.limit= 20;
      this.updatetable=!this.updatetable;
    },
    selectItem(item,index) {
        this.$emit("click", item);
    },  
    refresh() {
      this.$refs.tblArea.refresh();
    }
  }
};
</script>